class Config {
  private readonly SystemName = 'kamisato'
  private readonly isDevEnv = process.env.ctiEnv === 'development'
  private readonly Target = this.isDevEnv
    ? this.SystemName + '_dev'
    : this.SystemName
  // private readonly baseURL = this.isDevEnv
  //   ? 'https://api.' + this.SystemName + '.dev.cti-mobility.jp'
  //   : 'https://api.' + this.SystemName + '.cti-mobility.jp'

  private readonly Map: any = {
    center: {
      lat: 36.251635,
      lng: 139.144973
    },
    zoom: 14,
    DEV: {
      mapId: '5980adcd83c459dd',
      key: 'AIzaSyCS-4OoVXO5dL-P6OV1Ue8x8ocbBQ1n6kg'
    },
    PROD: {
      mapId: '2c8e059cb2d62d18',
      key: 'AIzaSyBmTme2UC6zOzmunfsEQTGgWEvAb7_S4xw'
    },
    v: 'quarterly',
    libraries: ['maps']
  }

  private readonly MapOptions: any = {
    center: this.centerCoordinates(),
    zoom: this.zoomLevel(),
    mapId: this.mapId(),
    maxZoom: 18,
    zoomControl: false,
    cameraControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    keyboardShortcuts: false,
    fullscreenControl: false,
    disableDefaultUI: true,
    gestureHandling: 'greedy',
    clickableIcons: false,
    disableDoubleClickZoom: true,
    headingInteractionEnabled: true,
    tiltInteractionEnabled: false
  }

  private readonly DEV_FirebaseConfig = {
    apiKey: 'AIzaSyA2hEHq2G32SI80dvv-s_Akg_eQhwy2R2Q',
    authDomain: 'cti-ondemand-255210.firebaseapp.com',
    databaseURL: 'https://cti-ondemand-255210.firebaseio.com',
    projectId: 'cti-ondemand-255210',
    storageBucket: 'cti-ondemand-255210.appspot.com',
    messagingSenderId: '271897390108',
    appId: '1:271897390108:web:26828b86dfb0cec11a83d9'
  }

  private readonly PROD_FirebaseConfig = {
    apiKey: 'AIzaSyBmTme2UC6zOzmunfsEQTGgWEvAb7_S4xw',
    authDomain: 'kamisato-project.firebaseapp.com',
    databaseURL: 'https://kamisato-project-default-rtdb.firebaseio.com',
    projectId: 'kamisato-project',
    storageBucket: 'kamisato-project.firebasestorage.app',
    messagingSenderId: '988337867800',
    appId: '1:988337867800:web:a8a70985e827f821e5476d'
  }

  private CollectionName: any = {
    Message: 'messages_' + this.Target,
    Operator: 'operators_' + this.Target
  }

  // baseURL(): any {
  //   return this.baseURL
  // }
  mapOptions(): any {
    return  this.MapOptions
  }
  centerCoordinates(): any {
    return this.Map.center
  }
  zoomLevel(): number {
    return this.Map.zoom
  }
  mapId(): string {
    return this.isDevEnv ? this.Map.DEV.mapId : this.Map.PROD.mapId
  }
  mapAPIkey(): string {
    return this.isDevEnv ? this.Map.DEV.key : this.Map.PROD.key
  }
  mapVersion(): string {
    return this.Map.v
  }
  mapLibraries(): [] {
    return this.Map.libraries
  }
  firebaseConfig(): any {
    return this.isDevEnv ? this.DEV_FirebaseConfig : this.PROD_FirebaseConfig
  }
  messageCollectionName(): string {
    return this.CollectionName.Message
  }
  operatorCollectionName(): string {
    return this.CollectionName.Operator
  }
}
const config = new Config()

export { config }
